import { render } from "./FilterSatuan.vue?vue&type=template&id=93567f0e"
import script from "./FilterSatuan.vue?vue&type=script&lang=js"
export * from "./FilterSatuan.vue?vue&type=script&lang=js"
script.render = render

export default script